import IsSymptom from "../../components/master/symptomChecker/steps/IsSymptom";
import IsSymptomDescription from "../../components/master/symptomChecker/steps/SymptomDescription";


const healthSymptomCheckerConfig = [IsSymptom,IsSymptomDescription];

export default healthSymptomCheckerConfig;